import script from "./NewUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./NewUsers.vue?vue&type=script&setup=true&lang=js"

import "./NewUsers.vue?vue&type=style&index=0&id=3d7331a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d7331a5"]])

export default __exports__